import { formattedTransactions } from 'lib/utils/generic';
import dayjs from 'dayjs';
import {
    Transaction,
    SectionHeaderItem,
    TransactionListItem,
} from 'lib/type/transactions';

type ListItem = SectionHeaderItem | TransactionListItem;

type TransactionWithFullName = Transaction & {
    targetAccount?: string;
    fullName?: string;
};

export const addFullNameTransactions = (
    arr: TransactionWithFullName[],
    recipients: Record<string, string>,
): TransactionWithFullName[] => {
    return arr.map(item => ({
        ...item,
        fullName: item.targetAccount ? recipients[item.targetAccount] : undefined,
    }));
};

export const getListItems = (transactions: Transaction[]): ListItem[] => {
    const formattedTransactionsObj = formattedTransactions(transactions);

    return Object.entries(formattedTransactionsObj)
        .sort(([a], [b]) => b.localeCompare(a))
        .reduce<ListItem[]>((acc, [date, transactionsByDate], index) => {
            const sectionHeading = dayjs(date).format('MMMM DD, YYYY');

            acc.push({
                key: sectionHeading,
                type: 'sectionHeader',
                text: sectionHeading,
                isFirstItem: index === 0,
            });

            transactionsByDate.forEach((transaction, i) => {
                acc.push({
                    key: `${i}-${transaction.createdDate}`,
                    type: 'transaction',
                    ...transaction,
                });
            });

            return acc;
        }, []);
};
